// Full staff name — first + middle + last (middle names were being dropped).
export const fullName = (emp) => {
  if (!emp) return '';
  const name = [emp.first_name, emp.middle_name, emp.last_name]
    .filter(p => p && String(p).trim())
    .map(p => String(p).trim())
    .join(' ');
  return name || emp.name || emp.employee_name || '';
};

export default fullName;
